import { createTheme } from '@mui/material/styles';
import { colors } from '../styles/colors.js';
import shippoTheme from '../styles/shippoTheme.js';

const accordionThemeInput = {
    components: {
        MuiAccordion: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                    borderRadius: 0,
                    padding: '0 2px',
                    borderBottom: `1px solid ${colors.borders}`,
                    '&:before': {
                        opacity: 0,
                    },
                    '&.Mui-expanded': {
                        '&:before': {
                            opacity: 0,
                        },
                    },
                },
            },
        },
    },
};
var accordionTheme = createTheme(shippoTheme, accordionThemeInput);

export { accordionThemeInput, accordionTheme as default };
//# sourceMappingURL=Accordion.theme.js.map
